module.exports = __webpack_public_path__ + "img/EP_AXBL-03.e9fa1433.png";